import L from 'leaflet';
import myw from 'myWorld-base';

/*
 * Leaflet handler to add ctrl-drag box interaction with a map
 * Fires a 'ctrldragbox-end' event on the map when the user releases the mouse button after dragging to create the box
 */

myw.CtrlDragBox = L.Handler.extend({
    options: {
        ctrlDragBox: true
    },

    initialize(map) {
        this._map = map;
        this._container = map.getContainer();
        this._pane = map.getPanes().overlayPane;
    },

    addHooks() {
        L.DomEvent.on(this._container, 'mousedown', this._onMouseDown.bind(this));
    },

    removeHooks() {
        L.DomEvent.off(this._container, 'mousedown', this._onMouseDown.bind(this));
    },

    /**
     * Set up event listeners and original mouse position
     * @param {event} e
     */
    _onMouseDown(e) {
        const interactionModeName = this._map.currentInteractionMode().constructor.name;
        if (
            !e.ctrlKey ||
            (e.which !== 1 && e.button !== 1) ||
            interactionModeName == 'GeomRotateMode' || //disable boxSelect when rotate or draw modes are enabled
            interactionModeName == 'GeomDrawMode'
        ) {
            return false;
        }
        this._map.dragging.disable();
        L.DomUtil.disableTextSelection();

        this._startLayerPoint = this._map.mouseEventToLayerPoint(e);
        //box is only created if/when there is a drag (mousemove)

        //TODO refactor: move cursor to styles
        this._container.style.cursor = 'crosshair';

        L.DomEvent.on(document, 'mousemove', this._onMouseMove, this);
        L.DomEvent.on(document, 'mouseup', this._onMouseUp, this);
    },

    /**
     * Record mouse position
     * @param {event}
     */
    _onMouseMove(e) {
        //create box in dom. //ENH: use our own css class
        if (!this._box) this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._pane);

        const startPoint = this._startLayerPoint;
        const box = this._box;
        const layerPoint = this._map.mouseEventToLayerPoint(e);
        const offset = layerPoint.subtract(startPoint);
        const newPos = new L.Point(
            Math.min(layerPoint.x, startPoint.x),
            Math.min(layerPoint.y, startPoint.y)
        );

        L.DomUtil.setPosition(box, newPos);

        // TODO refactor: remove hardcoded 4 pixels
        box.style.width = Math.max(0, Math.abs(offset.x) - 4) + 'px';
        box.style.height = Math.max(0, Math.abs(offset.y) - 4) + 'px';
    },

    /**
     * Remove box from GUI and remove events
     */
    _finish() {
        //Remove box from DOM
        if (this._box) this._box.parentNode.removeChild(this._box);
        this._box = null;
        this._container.style.cursor = '';

        L.DomUtil.enableTextSelection();

        //Turn off box mouse events
        L.DomEvent.off(document, 'mousemove', this._onMouseMove, this);
        L.DomEvent.off(document, 'mouseup', this._onMouseUp, this);

        this._map.dragging.enable();
    },

    /**
     * Sets current feature set to those in the box
     * @param {event} e
     */
    _onMouseUp(e) {
        //remove box from GUI
        this._finish();

        //Get new mouse coords
        const map = this._map;
        const layerPoint = map.mouseEventToLayerPoint(e);
        if (this._startLayerPoint.equals(layerPoint)) {
            return;
        }

        //Create coord string
        const latLngBounds = new L.LatLngBounds(
            map.layerPointToLatLng(this._startLayerPoint),
            map.layerPointToLatLng(layerPoint)
        );

        map.fire('ctrldragbox-end', { latLngBounds });
    }
});

export default myw.CtrlDragBox;
